import { createFileRoute } from '@tanstack/react-router'
import { LibraDashboardPage } from 'pages/libraDashboard/LibraDashboardPage'
import { libraDashboardSearchParamsSchema } from 'routes/libra-dashboard/-searchParams'

export const Route = createFileRoute('/libra-dashboard/')({
  component: RouteComponent,
  validateSearch: libraDashboardSearchParamsSchema,
  staticData: {
    title: 'Libra Dashboard',
    layout: {
      showNavbar: true,
      showSearchBar: false,
      enforceMaxWidth: false,
      enableScrolling: false,
    },
  },
})

function RouteComponent() {
  const search = Route.useSearch()
  return (
    <LibraDashboardPage
      groupId={search.group}
      unitId={search.unitId}
      orgId={search.orgId}
      dashboardConfigId={search.dashboardConfigId}
    />
  )
}
